export const MinusIcon = ({
  className,
}: {
  size?: number;
  className?: string;
}) => (
  <svg
    width='14'
    height='7'
    viewBox='0 0 14 7'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    aria-hidden='true'
  >
    <mask
      id='path-1-outside-1_224_4119'
      maskUnits='userSpaceOnUse'
      x='-0.475098'
      y='-0.538086'
      width='14'
      height='7'
      fill='black'
    >
      <rect fill='white' x='-0.475098' y='-0.538086' width='14' height='7' />
      <path d='M1.99987 1.99991H11.0539V4.14191H1.99987V1.99991Z' />
    </mask>
    <path d='M1.99987 1.99991H11.0539V4.14191H1.99987V1.99991Z' fill='white' />
    <path
      d='M1.99987 1.99991V-8.67844e-05C0.895302 -8.67844e-05 -0.000128865 0.895344 -0.000128865 1.99991H1.99987ZM11.0539 1.99991H13.0539C13.0539 0.895344 12.1584 -8.67844e-05 11.0539 -8.67844e-05V1.99991ZM11.0539 4.14191V6.14191C12.1584 6.14191 13.0539 5.24648 13.0539 4.14191H11.0539ZM1.99987 4.14191H-0.000128865C-0.000128865 5.24648 0.895302 6.14191 1.99987 6.14191V4.14191ZM1.99987 1.99991V3.99991H11.0539V1.99991V-8.67844e-05H1.99987V1.99991ZM11.0539 1.99991H9.05387V4.14191H11.0539H13.0539V1.99991H11.0539ZM11.0539 4.14191V2.14191H1.99987V4.14191V6.14191H11.0539V4.14191ZM1.99987 4.14191H3.99987V1.99991H1.99987H-0.000128865V4.14191H1.99987Z'
      fill='black'
      mask='url(#path-1-outside-1_224_4119)'
    />
  </svg>
);
